import React from 'react';
import {
  Typography,
  Divider,
  Card,
  Box,
  Avatar,
} from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Chip from '@mui/material/Chip';
import { Mentor } from 'types';

const useStyles = makeStyles(() =>
createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '400px',
    minheight: '420px',
    height: '420px',
    gap: '16px',
    padding: '24px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    boxshadow: '4px 4px 12px 0px #00000040',
    border: '1px solid #C6CBD3',
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.03)',
      transition: 'transform 0.3s',
    },
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'row',
    maxwidth: '352px',
    height: '80px',
    gap: '16px',
  },
  FontBoldL:{
    minwidth: '212px',
    height: '24px',
    fontFamily: 'Noto Sans TC',
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '30px',
    textAlign: 'left',
    color:'rgba(0, 0, 0, 1)',
  },
  FontMed:{
    fontFamily: 'Noto Sans TC',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '22.4px',
    textAlign: 'left',
    color:'rgba(0, 0, 0, 1)',
    whiteSpace: 'nowrap',
  },
  InfoChip:{
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    maxwidth: '352px',
    minwidth: '308px',
    height: '28px',
  },
  CustomChip:{
    width:'auto',
    maxwidth:'133px',
    height:'28px',
    borderRadius:'8px',
    padding:'12px',
    backgroundColor:'#C6F5D5',
    '& .MuiChip-label':{
      fontFamily:'Noto Sans TC',
      fontSize:'14px',
      fontWeight:400,
      lineHeight:'19.6px',
      color:'#000000DE',
      whiteSpace:'nowrap',
      padding:'0px',
      textAlign:'center',
    }
  },
  divider:{
    width: '352px',
    border: '1px solid #EEEEEE',
  },
  FontReg:{
    fontFamily: 'Noto Sans TC',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '22.4px',
    textAlign: 'left',
    maxHeight: '224px',
    overflowY: 'auto',
  },
  HelpList:{
    backgroundColor:'#F4F6FA',
    display:'flex',
    flexDirection:'column',
    width: '352px',
    height: '132px',
    padding: '8px',
    gap: '16px',
    borderRadius: '4px',
  },
  FontBoldM:{
    fontFamily: 'Noto Sans TC',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '22.5px',
    textAlign: 'left',
  },
  HelpListContent:{
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    width: '336px',
    height: '72px',
    whiteSpace: 'pre-wrap',
  }
})
);

interface MentorCardProps {
  mentor: Mentor;
  handleClick: (mentor:Mentor) => void;
}
export const MentorCard :React.FC<MentorCardProps>  = ({mentor, handleClick}) => {
  const classes = useStyles();

  const AvatorName = mentor.name.split(' ').map((name) => name[0]).join('');
  const renderTags = (tags: string[] | undefined, classes: any) => {
    if (!tags || tags.length === 0) return null;
    if (tags.length > 3) {
      return (
        <>
          {tags.slice(0, 2).map((label, index) => (
            <Chip key={index} className={classes.CustomChip} label={label} />
          ))}
          <Chip className={classes.CustomChip} label={`+${tags.length - 2}`} />
        </>
      );
    }

    return tags.map((label, index) => (
      <Chip key={index} className={classes.CustomChip} label={label} />
    ));
  };
  return (
      <Card onClick={() => handleClick(mentor)} className={classes.root}>
        <Box className={classes.userInfo}>
          <Avatar sx={{ width: 80, height: 80, fontSize: 36}}>{AvatorName}</Avatar>
          <Box sx={{display:'flex',flexDirection:'column',gap:'4px'}}>
            <Typography className={classes.FontBoldL}>{mentor.name}</Typography>
            {mentor.title ?
              <Box sx={{width: '212px', height: '24px'}}>
                <Typography className={classes.FontMed}>{mentor.title}</Typography>
              </Box> : null
            }
            {mentor.countryCode ?
              <Box sx={{width:'60px', height:'24px', gap:'4px', display:'flex', flexDirection:'row'}}>
                <LocationOnIcon color="disabled" sx={{width: '24px', height: '24px'}}/>
                <Typography className={classes.FontMed}>{mentor.countryCode}</Typography>
              </Box>: null
            }
          </Box>
        </Box>
        <Box className={classes.InfoChip}>
          {renderTags(mentor.tags, classes)}
        </Box>
        <Divider/>
        <Box sx={{minwidth: '308px', maxWidth: '352px'}}>
          <Typography className={classes.FontReg}>{mentor.profileBio}</Typography>
        </Box>
        {/* <Box className={classes.HelpList}>
          <Box sx={{width: '336px', height: '23px'}}>
            <Typography className={classes.FontBoldM}>我可以提供哪些幫助？</Typography>
          </Box>
          <Box className={classes.HelpListContent}>
            <Typography className={classes.FontReg}>想要幫助跟我一樣在海外找工作的人。我可以分享我從學生簽轉H1B簽證的經驗，包括申請策略、文件準備，以及面試準備技巧。如果你正尋找關於如何在美國從學生身份順利過渡到職場的建議，我也樂於協助。</Typography>
          </Box>
        </Box> */}
      </Card>
  );
};

export default MentorCard;